// src/hooks/useVisitors.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for visitors management
 * Connects to AppContext for centralized state management
 */
export const useVisitors = () => {
    const { state, actions } = useAppContext();
    
    return {
        // State
        visitors: state.visitors || [],
        loading: state.loading,
        error: state.error,
        guidVisitor: state.guidVisitor,
        visitorSubmited: state.visitorSubmited,
        currentInvitation: state.currentInvitation,
        
        // Actions
        fetchVisitors: actions.fetchVisitors,
        createVisitor: actions.createVisitor,
        getVisitorByGuid: actions.getVisitorByGuid,

        // Invitation Security Flow actions (TOTP / OTP)
        getInvitationDetails: actions.getInvitationDetails,
        requestOtp: actions.requestOtp,
        activateInvitation: actions.activateInvitation,
        createInvitation: actions.createInvitation,
        cancelInvitation: actions.cancelInvitation,

        // Utility functions
        getVisitorById: (visitorId) => {
            return state.visitors?.find(visitor => visitor.id === visitorId);
        },

        getActiveVisitors: () => {
            return state.visitors?.filter(visitor => visitor.active) || [];
        },

        getVisitorCount: () => state.visitors?.length || 0,

        searchVisitors: (searchTerm) => {
            if (!searchTerm) return state.visitors || [];
            const term = searchTerm.toLowerCase();
            return state.visitors?.filter(visitor => 
                (visitor.name && visitor.name.toLowerCase().includes(term)) ||
                (visitor.email && visitor.email.toLowerCase().includes(term)) ||
                (visitor.phone && visitor.phone.toLowerCase().includes(term))
            ) || [];
        }
    };
};

export default useVisitors;
